import React from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'

import styles from './Employee.module.scss'

const Employee = ({ name, title, imgSrc }) => (
  <div className={styles.wrapper}>
    <span className={styles.photoWrapper}>
      <Image
        alt={name}
        className={styles.photo}
        height={180}
        src={imgSrc}
        width={180}
      />
    </span>
    <h4 className={styles.name}>{name}</h4>
    <p className={styles.title}>{title}</p>
  </div>
)

Employee.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  imgSrc: PropTypes.string,
}

export default Employee
